// extracted by mini-css-extract-plugin
module.exports = {"emptyTarget":"notifications_emptyTarget__32Q_6","notificationsWrapper":"notifications_notificationsWrapper__1t9cq"};